@let user = this.user();
@if (user) {
  <button [matMenuTriggerFor]="userMenu" matButton class="tertiary small w-full">
    <span class="flex w-full flex-col">
      <span class="flex items-center">
        <span class="my-1.5 mr-2 flex min-w-0 flex-auto items-center gap-x-3">
          <aura-avatar
            [srcImage]="$safeNavigationMigration(user.identity.avatar?.url)"
            [label]="user.identity.firstName"
            [isAdmin]="isAdmin()"
          />
          <div class="flex flex-col flex-1 min-w-0 max-w-[140px] text-start">
            <span class="flex items-center gap-1.5 min-w-0">
              <span class="block truncate font-semibold">{{ user.identity.firstName }}</span>
              @if (user.identity.verificationStatus === Status.VERIFIED) {
                <aura-identity-status [status]="user.identity.verificationStatus" />
              }
            </span>
            <span class="block truncate text-sm">{{ user.contactInfos.email | obfuscateEmail }}</span>
          </div>
        </span>

        <mat-icon class="ml-auto" svgIcon="ellipsis-vertical" iconPositionEnd />
      </span>
      @if (isAdmin() && layout() === 'sidebar_auxiliary') {
        <mat-divider class="my-1.5" />
        <div class="mb-0.5 w-full">
          <div
            class="flex items-center justify-center gap-1.5 rounded-md bg-primary-a3 py-1 px-2.5 text-xs font-semibold text-primary-11 border border-primary-a4 shadow-xs"
          >
            <mat-icon svgIcon="shield" class="!size-3.5 text-primary-9" />
            <span>Administrateur</span>
          </div>
        </div>
      }
    </span>
  </button>

  <!-- User Menu -->
  <mat-menu #userMenu class="w-56" xPosition="before">
    @if (user.subscription) {
      <div class="px-3 py-2">
        <aura-user-subscription-status [user]="user" />
      </div>
      <mat-divider />
    }
    @if (isAgent()) {
      <button [matMenuTriggerFor]="settingsMenu" mat-menu-item>
        <mat-icon svgIcon="settings" />
        <span>Paramètres</span>
      </button>
      <mat-menu #settingsMenu="matMenu">
        <button mat-menu-item routerLink="/user/settings">
          <mat-icon svgIcon="circle-user" />
          <span>Compte</span>
        </button>
        @if (isCurrentAppAgent()) {
          <button mat-menu-item routerLink="/user/agent/settings">
            <mat-icon svgIcon="id-card" />
            <span>Professionnel</span>
          </button>
        } @else {
          <a mat-menu-item [href]="agentProfileUrl()">
            <mat-icon svgIcon="id-card" />
            <span>Professionnel</span>
          </a>
        }
      </mat-menu>
    } @else {
      <button mat-menu-item routerLink="/user/settings">
        <mat-icon svgIcon="settings" />
        <span>Paramètres</span>
      </button>
    }

    <!--
    <button mat-menu-item>
      <mat-icon svgIcon="bell" />
      <span>Notifications</span>
    </button>
    -->

    <mat-divider />

    <button mat-menu-item routerLink="/help-center">
      <mat-icon>info</mat-icon>
      <span>Centre d'aide</span>
    </button>

    <button [matMenuTriggerFor]="schemeMenu" mat-menu-item>
      <mat-icon svgIcon="sun-moon" />
      <span>Mode d'apparence</span>
    </button>
    <mat-menu #schemeMenu>
      @for (item of schemes; track item.value) {
        <button (click)="updateScheme(item.value)" mat-menu-item>
          <mat-pseudo-checkbox
            [state]="scheme() === item.value ? 'checked' : 'unchecked'"
            appearance="minimal"
          />
          <span class="ml-1">{{ item.label }}</span>
        </button>
      }
    </mat-menu>

    @if (isAdmin()) {
      <button mat-menu-item>
        <mat-icon>bug_report</mat-icon>
        <span>Mode debug</span>
        <span class="flex-1"></span>

        <mat-checkbox
          [checked]="appStore.debugMode()"
          (click)="appStore.toggleDebug(!appStore.debugMode())"
        />
      </button>
    }

    <mat-divider />

    @if (isImpersonated()) {
      <button mat-menu-item (click)="closeImpersonate()">
        <mat-icon>sync_alt</mat-icon>
        <span>Revenir à mon compte</span>
      </button>
    }
    <button mat-menu-item routerLink="/auth/sign-out" [disabled]="isImpersonated()">
      <mat-icon svgIcon="log-out" />
      <span>Se déconnecter</span>
    </button>
  </mat-menu>
}
